import { render } from "./FixWrapper.vue?vue&type=template&id=6942e1ad&scoped=true"
import script from "./FixWrapper.vue?vue&type=script&lang=js"
export * from "./FixWrapper.vue?vue&type=script&lang=js"

import "./FixWrapper.vue?vue&type=style&index=0&id=6942e1ad&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6942e1ad"]])

export default __exports__